import getCookie, { setCookie } from './cookies';
import { hashEmailMd5 } from './hashes';

export const setRubIdCookie = (email: string) => {
	const emailHash = hashEmailMd5(email);
	const rubId = getCookie('RubID');

	if (rubId !== emailHash) setCookie('RubID', emailHash, 1);
};
